import {absCenterY, font_s_md} from '@xpertdox_js/xdstyle';

export default {
  container: {
    position: 'relative',
  },
  input: {
    ...font_s_md,
    height: '50px',
    maxHeight: '120px',
    display: 'block',
    width: '100%',
    background: '#fff',
    border: '1px solid rgba(14,10,22,0.24)',
    borderRadius: '4px',
    padding: '8px',
  },
  submit: {
    position: 'absolute',
    left: 'auto',
    display: 'block',
    right: '1px',
    top: '1px',
    bottom: '1px',
    height: 'auto',
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: '1px solid rgba(14,10,22,0.14)',
  }
};
